// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".jgile-repeater .repeater-repeated{position:relative;border-bottom:1px solid #ddd;padding:15px 0}.jgile-repeater .repeater-repeated .repeater-repeated-controls{position:absolute;top:0;right:0;bottom:0}.jgile-repeater .repeater-repeated:last-child{border-bottom:none}", ""]);
// Exports
module.exports = exports;
